<template lang="pug">
router-link.d-flex.gap-2.align-center(
  to="/"
)
  template
    christmas-tree(large).ml-n1
    app-avatar.transparent(
      v-if="logo"
      :avatar="logo"
      icon="$logo"
      :size="size"
      :icon-attrs="{ size }"
      contain
    )
    v-icon(v-else large) $logo
    template(v-if="!hideName")
      span Афиша #[br] мероприятий
</template>

<script>
import AppAvatar from '@/components/user-redesign/AppAvatar.vue';
import ChristmasTree from '@/components/global/ChristmasTree.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    size: {
      type: Number,
      default: 35,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AppAvatar,
    ChristmasTree,
  },
  computed: {
    ...mapGetters({
      settings:'settings',
    }),

    logo() {
      return this.settings.logo;
    },
  },
};
</script>
